import { jsonApi } from '@models/jsonApi';

jsonApi.define('delivery/trend', {
  connector_type: '',
  datasets: [],
});
